/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreServiceKey {
  static readonly LOCALE = 'kit-core/service/locale';
  static readonly TEXT = 'kit-core/service/text';
  static readonly RESOURCE = 'kit-core/service/resource';
  static readonly MESSAGE = 'kit-core/service/message';
  static readonly ALERT = 'kit-core/service/alert';
}
